import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  Icon,
  useCheckboxGroup,
  useDisclosure,
  useRadioGroup,
} from '@chakra-ui/react';
import { RecipeTagsResponse } from '@diamond/shared/types';
import { Divider } from '@diamond/shared/ui';
import { SortOutlined } from '@mui/icons-material';

import { RecipeListCategoryCheckbox } from './RecipeListCategoryCheckbox';
import { RecipeListRadio } from './RecipeListRadio';

type RecipeFilterMobileProps = {
  categories: RecipeTagsResponse;
};

export function RecipeFilterMobile({ categories }: RecipeFilterMobileProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { getCheckboxProps } = useCheckboxGroup();
  const { getRadioProps } = useRadioGroup();

  return (
    <>
      <Button
        variant="outline"
        px="6"
        backgroundColor="white"
        onClick={onOpen}
        rightIcon={<Icon as={SortOutlined} />}
      >
        Urutkan
      </Button>
      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent borderTopRadius="2xl">
          <DrawerCloseButton />
          <DrawerHeader>Filter</DrawerHeader>
          <Divider borderColor="gray.33" />
          <DrawerBody>
            <Heading fontSize="xl" mb="3">
              Kategori
            </Heading>
            <Flex flexWrap="wrap" gap="2">
              {categories.data.map((c) => (
                <RecipeListCategoryCheckbox
                  key={c.id}
                  type="simple"
                  label={c.name}
                  {...getCheckboxProps({ value: c.id })}
                />
              ))}
            </Flex>
            <Heading fontSize="xl" mt="6" mb="3">
              Urutan
            </Heading>
            <Flex flexWrap="wrap" gap="2">
              {sortFilters.map((c) => (
                <RecipeListRadio
                  key={c.value}
                  label={c.label}
                  {...getRadioProps({ value: c.value })}
                />
              ))}
            </Flex>
          </DrawerBody>
          <DrawerFooter>
            <Button colorScheme="blue" w="full">
              Terapkan
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}

const sortFilters = [
  { value: 'popular', label: 'Banyak Dilihat' },
  { value: 'asc', label: 'A-Z' },
  { value: 'desc', label: 'Z-A' },
  { value: 'latest', label: 'Terbaru' },
];
